import { useMutation } from "@tanstack/react-query";

import fetchJSON from "../lib/reactQueryClient";
import {
  PRODUCT_ID,
  TENANT_ID,
  API_ENDPOINTS,
  DEFAULT_ISD_CODE,
  DEFAULT_PLATFORM,
} from "../constants/constants";
import { normalizeSearchAgentsResponse } from "../adapters/searchAgentAdapter";

export const searchAgents = async ({ phone }) => {
  const options = {
    method: "POST",
    headers: {
      "product-id": PRODUCT_ID,
      "tenant-id": TENANT_ID,
      platform: DEFAULT_PLATFORM,
    },
    body: {
      phone,
      isd_code: DEFAULT_ISD_CODE,
    },
  };

  const response = await fetchJSON(API_ENDPOINTS.SEARCH_AGENTS, options);
  return normalizeSearchAgentsResponse(response);
};

export const useSearchAgents = () => useMutation({ mutationFn: searchAgents });
